<template>
    <div class="form-elements">
        <div class="row">
            <div class="col-md-12">
                <vuestic-widget headerText="Usuários">
                  <div class="row">
                    <div class="col-md-12">
                      <table class="table table-responsive-sm">
                        <thead>
                          <tr>
                            <td colspan="22">
                              Permissões
                            </td>
                          </tr>
                          <tr>
                            <th>#</th>
                            <template v-for="role in roles">
                              <th :key="role.constante_funcao_usuario">{{ role.funcao_usuario }}</th>
                            </template>
                          </tr>
                        </thead>
                        <tbody v-for="(permission, index) in roles[0].permissions" :key="index + '-' + permission">
                          <tr v-if="permission != 2">
                            <td width="300px">
                              {{ permissions[index] }}
                            </td>
                            <td>
                              <label v-if="permission" class="switch">
                                <input :id="index + '-' + roles[0].id_funcao_usuario" type="checkbox" checked @click="updatePermission(roles[0].id_funcao_usuario, index, permission)">
                                <span class="slider round"></span>
                              </label>
                              <label v-else class="switch">
                                <input :id="index + '-' + roles[0].id_funcao_usuario" type="checkbox" @click="updatePermission(roles[0].id_funcao_usuario, index, permission)">
                                <span class="slider round"></span>
                              </label>
                            </td>
                            <td>
                              <label v-if="roles[1].permissions[index]" class="switch">
                                <input :id="index + '-' + roles[1].id_funcao_usuario" type="checkbox" checked @click="updatePermission(roles[1].id_funcao_usuario, index, roles[1].permissions[index])">
                                <span class="slider round"></span>
                              </label>
                              <label v-else class="switch">
                                <input :id="index + '-' + roles[1].id_funcao_usuario" type="checkbox" @click="updatePermission(roles[1].id_funcao_usuario, index, roles[1].permissions[index])">
                                <span class="slider round"></span>
                              </label>
                            </td>
                            <td>
                              <label v-if="roles[2].permissions[index]" class="switch">
                                <input :id="index + '-' + roles[2].id_funcao_usuario" type="checkbox" checked @click="updatePermission(roles[2].id_funcao_usuario, index, roles[2].permissions[index])">
                                <span class="slider round"></span>
                              </label>
                              <label v-else class="switch">
                                <input :id="index + '-' + roles[2].id_funcao_usuario" type="checkbox" @click="updatePermission(roles[2].id_funcao_usuario, index, roles[2].permissions[index])">
                                <span class="slider round"></span>
                              </label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </vuestic-widget>
            </div>
        </div>
    </div>
</template>

<script>
import UsuariosController from './UsuariosController'
import { Serialize } from '../../services/serializeFormData'

export default {
  name: 'permissoes',
  components: {

  },
  data(){
    return{
      roles: [],
      roles_ids: [],
      permissions:{
        'cfcs': 'CFCs',
        'user_edit': 'Editar Usuários',
        'user_list': 'Listar Usuários',
        'permissoes': 'Permissões',
        'veiculo_list': 'Listar Veículos',
        'veiculo_edit': 'Editar Veículos',
        'instrutor_list': 'Listar Instrutores',
        'instrutor_edit': 'Editar Instrutores',
        'alunos_list': 'Listar Alunos',
        'alunos_edit': 'Editar Alunos',
        'turmas_list': 'Listar Turmas',
        'turmas_edit': 'Editar Turmas',
        'agendamento': 'Agendamento',
        'aulas_list': 'Listar Aulas',
        'planos': 'Planos de Aula Prática',
        'monitoramento_teorica': 'Monitoramento Teórico',
        'monitoramento_relatorios': 'Relatório de Monitoramento Teórico',
        'faturas_teoricas': 'Faturas Teóricas',
        'faturas_praticas': 'Faturas Práticas',
        'relatorios': 'Relatórios'
      }
    }
  },
  mounted (permissions) {
    this.loadData()
  },
  methods:{
    loadData () {
        let self = this
        UsuariosController.getfuncoesUsuarios(function (data) {
          data.forEach(value => {
            if(value.id_funcao_usuario != 1 && value.id_funcao_usuario != 4){
              self.roles.push(value)
              self.roles_ids.push(value.id_funcao_usuario)
            }
          });
        })

    },
    updatePermission (id_funcao_usuario, index, value) {
      var slider = document.getElementById(index + '-' + id_funcao_usuario)
      UsuariosController.updatePermission(id_funcao_usuario, index, slider.checked)
      },

  }
}
</script>

<style>
  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: #4ae387;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #4ae387;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
</style>

